/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */



  window.addEventListener('load', (event)=> {
  var style = document.createElement( 'style' );
  let host = document.querySelector('chat-widget');
  style.innerHTML = '.lc_text-widget--prompt{ bottom: 40px !important;max-width: 100% !important;} #lc_text-widget--btn{bottom: 60px !important;background-color:#663300;background:linear-gradient(120deg, rgba(102, 51, 0, 1), rgba(176, 124, 36, 1));} @media screen and (max-width: 768px){.lc_text-widget--prompt{ bottom: 40px !important;}}';
  host.shadowRoot.appendChild( style )
});



$('.more-less-btn').click(function() {
  $('.more_text').slideToggle();
  if ($('.more-less-btn').text() == "Read more") {
    $(this).text("Read less")
  } else {
    $(this).text("Read more")
  }
});



$(document).ready(function() { 
    // Business hours in EST (24hr format)
    const hours = window.hours;

    function getNowEST() {
      return new Date(
        new Date().toLocaleString("en-US", { timeZone: "America/New_York" })
      );
    }

    function formatHour(hour) {
      const ampm = hour >= 12 ? "pm" : "am";
      let display = hour % 12;
      if (display === 0) display = 12;
      return display + ampm;
    }

    function getNextOpen(day) {
      for (let i = 1; i <= 7; i++) {
        const nextDay = (day + i) % 7;
        if (hours[nextDay]) {
          return { day: nextDay, open: hours[nextDay].open };
        }
      }
      return null;
    }

    function updateStatus(el) {
      const now = getNowEST();
      const day = now.getDay();
      const hour = now.getHours();
      const today = hours[day];

      if (today && hour >= today.open && hour < today.close) {
        // OPEN
        el.textContent = `Online until ${formatHour(today.close)} EST`;
        el.classList.add("is-open");
        el.classList.remove("is-closed");
      } else {
        // CLOSED
        let nextOpen;
        if (today && hour < today.open) {
          nextOpen = { day, open: today.open };
        } else {
          nextOpen = getNextOpen(day);
        }

        if (nextOpen) {
          const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
          const diff = (nextOpen.day - day + 7) % 7;
          const dayLabel =
            diff === 0 ? "" : diff === 1 ? "tomorrow" : days[nextOpen.day];
          el.textContent = `Opens ${dayLabel} ${formatHour(nextOpen.open)} EST`;
        } else {
          el.textContent = "Closed";
        }

        el.classList.remove("is-open");
        el.classList.add("is-closed");
      }
    }

    // Update all .status elements
    function updateAllStatuses() {
      document.querySelectorAll(".status").forEach(updateStatus);
    }

    updateAllStatuses();
    setInterval(updateAllStatuses, 60000); // refresh every minute


});

document.addEventListener('variant:changed', function(event) {
  const variant = event.detail.variant;
  if (variant && variant.featured_media) {
    const mediaId = variant.featured_media.id;
    const thumbnail = document.querySelector(
      `.product__thumbnail-item[data-media-id="${mediaId}"]`
    );
    if (thumbnail) {
      thumbnail.click();
    }
  }
});


document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('AddToCartForm-main-product');
  if (!form) return;

  form.addEventListener('variant:changed', async function(event) {
    const variant = event.detail.variant;
    if (!variant) return;

    const sectionId = 'main-product';
    const url = `${window.location.pathname}?variant=${variant.id}&section_id=${sectionId}`;
    
    try {
      const response = await fetch(url);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      
      const newPriceList = doc.querySelector('[data-product-price-list]');
      const currentPriceList = document.querySelector('[data-product-price-list]');

      if (newPriceList && currentPriceList) {
        currentPriceList.innerHTML = newPriceList.innerHTML;
      }

      const newLabelList = doc.querySelector('[data-product-label-list]');
      const currentLabelList = document.querySelector('[data-product-label-list]');
      if (newLabelList && currentLabelList) {
        currentLabelList.innerHTML = newLabelList.innerHTML;
      }
    } catch (error) {
      console.error('Failed to update section:', error);
    }
  });
});
